<template>
  <svg
    :height="height"
    :width="width"
    version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
     viewBox="0 0 511.999 511.999" style="enable-background:new 0 0 511.999 511.999;" xml:space="preserve">
    <path opacity="0.6" :fill="iconColor" d="M474.125,3.263c-3.603-2.859-8.314-3.914-12.79-2.867L155.34,71.889
      c-6.816,1.593-11.637,7.67-11.637,14.669v296.696c-11.526-8.124-25.56-12.915-40.701-12.915c-39.056,0-70.83,31.775-70.83,70.829
      s31.775,70.829,70.83,70.829s70.83-31.775,70.83-70.829V187.292l275.865-64.454V311.76c-11.526-8.124-25.56-12.915-40.7-12.915
      c-39.056,0-70.829,31.775-70.829,70.83s31.775,70.829,70.829,70.829s70.829-31.775,70.829-70.829V15.065
      C479.827,10.467,477.727,6.12,474.125,3.263z"/>
    <path opacity="0.4" :fill="iconColor" d="M474.125,3.263c-3.603-2.859-8.314-3.914-12.79-2.867L291.431,40.092v119.724l158.266-36.978V311.76
      c-11.526-8.124-25.56-12.915-40.7-12.915c-39.056,0-70.829,31.775-70.829,70.83s31.775,70.829,70.829,70.829
      s70.829-31.775,70.829-70.829V15.065C479.827,10.467,477.727,6.12,474.125,3.263z"/>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
    <g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: [Number, String],
      default: 18
    },
    height: {
      type: [Number, String],
      default: 18
    },
    iconColor: {
      type: String,
      default: 'currentColor'
    }
  }
}
</script>
